const dayjs = require('dayjs');
const weekday = require('dayjs/plugin/weekday');
dayjs.extend(weekday);

class DateUtil {

    static isBefore(dateA, dateB) {
        return dayjs(dateA).isBefore(dayjs(dateB));
    }

    static getReportDate(date) {
        return `${DateUtil.format(date, "YYYY/MM/DD")}(${DateUtil.getWeekDayStr(date)})`;
    }

    static isSameDay(dateA, dateB, unit = 'd') {

        const a = dayjs(dateA);
        const b = dayjs(dateB);
        return a.diff(b, unit) === 0;
    }

    static format(date, format = 'YYYY/MM/DD') {

        if (date) return dayjs(date).format(format);
        else return date;
    }

    static toDate(dateStr, format = 'YYYY/MM/DD') {

        if (dateStr) return dayjs(dateStr, format).toDate();
        else return dateStr;
    }

    static getWeekDayStr(date) {

        const weekdayMap = {
            0: '日',
            1: '一',
            2: '二',
            3: '三',
            4: '四',
            5: '五',
            6: '六',
        };

        return weekdayMap[dayjs(date).weekday()];
    }

    static yesterday = () => dayjs().add(-1, 'd').toDate();
    static startOf = (date, unit = 'd') => dayjs(date).startOf(unit).toDate();
    static endOf = (date, unit = 'd') => dayjs(date).endOf(unit).toDate();
}

module.exports = DateUtil;
